@let parentCategoryDropdownItemsValue = parentCategoryDropdownItems();
@let campTypeDropdownItemsValue = campTypeDropdownItems();
@let isBusyValue = isBusy();

<div class="empty-panel"></div>
<div class="side-panel">
    <h1 class="title">{{ 'ManageImages.Header' | translate }}</h1>
    <form [formGroup]="" class="voffset-20">
        <div class="form-group form-horizontal">
            <div class="row voffset20">
                <div class="col-12">
                    <div class="form-group form-horizontal">
                        <label class="panel-label">{{ 'ManageImages.CampType' | translate }}</label>
                        <bcu-drop-down-multiselect-cf2
                            #campTypeDropdown
                            [isDisabled]="isBusyValue"
                            [options]="campTypeDropdownItemsValue"
                            [shortenWhenAllSelected]="true"
                            [selectAllOption]="true"
                            (changed)="onCampTypeChanged($event)"
                        >
                        </bcu-drop-down-multiselect-cf2>
                    </div>
                </div>
            </div>
            <hr />

            <div class="row voffset20">
                <div class="col-12">
                    <div class="form-group form-horizontal">
                        <label class="panel-label">{{ 'ManageImages.Category' | translate }}</label>
                        <bcu-drop-down-multiselect-cf2
                            #parentCategoryDropdown
                            [isDisabled]="isBusyValue"
                            [options]="parentCategoryDropdownItemsValue"
                            [shortenWhenAllSelected]="true"
                            [selectAllOption]="true"
                            (changed)="onParentCategoriesChanged($event)"
                        >
                        </bcu-drop-down-multiselect-cf2>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
